export const getUserId = (): string => {
    const url = new URL(window.location.href);
    return url.searchParams.get('vk_user_id') as string;
};
